import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Collapse } from 'reactstrap';
import moment from 'moment';
import * as types from '../../constants/prayerFeatureActionTypes';
import * as consts from '../../constants/prayerFeatureConstants';
import * as msgs from "../../constants/textConstants";
import CommentCard from './CommentCard';
import CommentForm from './CommentForm';
import { Typography, Divider, Badge, Icon, Card, Modal, Radio, LinkText } from "../ecosystem";
import { DropDownButtonMenu } from "../ecosystem/mybswh";

function PrayerCard({ prayer, memberId, userRole, prayerCommentsMaxLimit, isSuperAdmin,
    deletePrayer, notifyDeletedPrayer, banUser, addPrayerReaction, removePrayerReaction,
    getComments, getAllPrayers, getMyPrayers, onEdit, onActionComplete, screenBreakPoint
}) {
    const [showDeletePostModal, setShowDeletePostModal] = useState(false);
    const [banningUser, setBanningUser] = useState(false);
    const [showComments, setShowComments] = useState(false);
    const [allComments, setAllComments] = useState(null);
    const [reasonForDelete, setReasonForDelete] = useState(null);

    let data = null;
    let _liveObject = null;
    let _updateCount = 0;

    try {
        data = prayer && prayer.data && JSON.parse(prayer.data.text);
        if (data === null) {
            data = prayer.data.text;
        }
    } catch (ex) {
        //console.error(ex);
        if (data === null) {
            data = prayer.data.text;
        }
    }

    const isMobile = !(screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;
    const isTabletBP = !(screenBreakPoint === msgs.LG_TABLET || screenBreakPoint === msgs.XL_DESKTOP || screenBreakPoint === msgs.XXL_DESKTOP) ? true : false;
    const timeCreatedAt = prayer.editedAt;
    const createdDateInMiliSec = new Date(timeCreatedAt).getTime();
    const createdTime = moment(timeCreatedAt).format('LL');
    const relativeCreatedTime = moment(timeCreatedAt).fromNow();
    const isPrayerOfTheWeek = prayer && prayer.tags && prayer.tags.indexOf('prayerOfTheWeek') > -1;

    useEffect(() => {

        return () => {
            if (_liveObject) {
                _liveObject.dispose();
            }
        };
    }, []);

    const _deletePrayer = (prayer) => {
        //if (prayer.metadata) {
        //    prayer.metadata.reasonForDelete = reasonForDelete;
        //}
        //else {
        //    prayer.metadata = { reasonForDelete };
        //}
        deletePrayer(prayer, reasonForDelete, success => {
            onActionComplete(success ?
                { success, confirmationMessage: consts.DELETE_POST_SUCCESS } :
                { success, confirmationMessage: consts.DELETE_POST_ERROR },
                !success
            );
            if (success) {
                notifyDeletedPrayer(prayer, reasonForDelete);//.charAt(0).toLowerCase() + reasonForDelete.slice(1));
            }
        });
        setShowDeletePostModal(false);
    };

    const reactionCallback = success => {
        if (!success) {
            onActionComplete({ success, confirmationMessage: consts.ACTION_ERROR }, true);
        }
        //    else {
        //        getAllPrayers();
        //    }
    };

    const handlePrayerReaction = (postId) => {
        if (!prayer.myReactions.includes("love")) {
            addPrayerReaction(postId, reactionCallback);
        }
        else {
            removePrayerReaction(postId, reactionCallback);
        }
    };

    const updateComments = (comments, sort) => {
        if (/*sort && */comments) {
            comments = comments.sort((a, b) => a.createdAt < b.createdAt ? -1 : 0);
        }
        const commentIds = comments.map(comment => comment.commentId);
        setAllComments(commentIds);
        getAllPrayers();
    }

    const _getComments = (sort) => {
        getComments(prayer.postId, liveObject => {
            if (_liveObject === null && liveObject) {
                _liveObject = liveObject;
                if (_liveObject.models) {
                    updateComments(_liveObject.models, sort);
                }
                if (_updateCount === 0) {
                    _liveObject.on('dataUpdated', comments => {
                        _updateCount++;
                        updateComments(comments, sort);
                        if (_updateCount > 1) {
                            _liveObject.dispose();
                            _updateCount = 0;
                        }
                    });
                }
            }
        });
    }

    const onCommentActionComplete = response => {
        if (response.success) {
            _getComments(true);
        }
        onActionComplete(response);
    }

    const showHideComments = () => {
        if (allComments === null) {
            if (prayer.commentsCount > prayer.comments.length) {
                _getComments();
            }
            else {
                setAllComments(prayer.comments);
            }
        }
        setShowComments(!showComments);
    };

    const timeDifference = (current, previous) => {
        const elapsed = current - previous;
        const hours = Math.round(elapsed / (60 * 60 * 1000));
        return `${hours <= 1 ? 'Just Now' : hours + ' Hours Ago'}`;
    };

    const isCreatedHoursAgo = (dates, hours) => {
        const fourtyEightHr = 1000 * 60 * 60 * hours;
        const fourtyEightHrAgo = Date.now() - fourtyEightHr;
        return dates > fourtyEightHrAgo;
    };

    const timeAgo = (isCreatedHoursAgo, createdDateInMiliSec, relativeCreatedTime, createdTime, currentTime) => {
        /*if (isCreatedHoursAgo(createdDateInMiliSec, 1)) {
            return relativeCreatedTime;
        } else*/ if (isCreatedHoursAgo(createdDateInMiliSec, 24)) {
            return timeDifference(currentTime, createdDateInMiliSec);
        } else if (isCreatedHoursAgo(createdDateInMiliSec, 48)) {
            return 'Yesterday';
        } else {
            return createdTime;
        }
    };

    const timeCreated = timeAgo(isCreatedHoursAgo, createdDateInMiliSec, relativeCreatedTime, createdTime, Date.now());

    if (!data) return;


    const modalHeader = () => {
        return (
            <>
                {consts.DELETE_POST_HEADER}
            </>
        )
    }

    const modalBody = () => {
        //bugfix 178658 const modalOptions = consts.DELETE_OPTIONS.split('|').map(option => option.charAt(0).toUpperCase() + option.slice(1));
        return (
            <><div className="prayer-modal-body">
                <div className="prayer-modal-body__subtitle">
                    {consts.DELETE_POST_HEADER}
                    <div>{consts.DELETE_SECOND_HEADER}</div>
                </div>
                {/*<div className="prayer-modal-body__form-container">
                    {modalOptions.map((option, index) => {
                        return (
                            <Radio
                                label={option}
                                selected={reasonForDelete}
                                onChange={() => setReasonForDelete(option)}
                                disabled={false}
                                key={index}
                                index={index}
                                variant="select"
                                size="md"
                            />)
                    })}
                </div>*/}
            </div>
            </>
        )
    }

    const modalFooter =
        [
            {
                label: "Yes, delete post",
                disabled: false, // bugfix 178658 !reasonForDelete,
                onClick: () => { _deletePrayer(prayer); /*setReasonForDelete("");*/ }
            },
            {
                label: "Cancel",
                onClick: () => { setShowDeletePostModal(false); /*setReasonForDelete("");*/ }
            }
        ]


    const banningUserModalBody = () => {
        return (
            <div>
                <div>{consts.BAN_USER_HEADER}{isTabletBP ? ' ' : <br /> }
                {consts.BAN_USER_SECOND_HEADER}</div>
            </div>
        )
    }

    const banningUserModalFooter =
        [
            {
                label: "Yes, ban user",
                onClick: () => {
                    deletePrayer(prayer, 'user banned', success => {
                        if (success) {
                            notifyDeletedPrayer(prayer, 'user banned');
                            banUser(prayer.postedUserId, (response, error) => {
                                setBanningUser(false);
                                onActionComplete(error ?
                                    { success: !error, confirmationMessage: consts.BAN_USER_ERROR } :
                                    { success: !error, confirmationMessage: consts.BAN_USER_SUCCESS },
                                    error
                                );
                            });
                        } else {
                            setBanningUser(false);
                            onActionComplete(
                                { success, confirmationMessage: consts.BAN_USER_ERROR },
                                !success
                            );
                        }
                        const userId = prayer.postedUserId;
                        getMyPrayers(userId, livePrayers => {
                            if (livePrayers) {
                                livePrayers.on('dataUpdated', prayers => {
                                    if (prayers && prayers.length && prayers[0].postedUserId === userId) {
                                        prayers.forEach(p => deletePrayer(p, 'user banned'));
                                        if (livePrayers.hasMore) {
                                            livePrayers.nextPage();
                                        }
                                        else {
                                            liveMyPrayers.dispose();
                                            livePrayers = null;
                                        }
                                    }
                                });
                                livePrayers.on('dataError', error => {
                                    console.log('getMyPrayers', error);
                                });
                            }
                        });
                    });
                }
            },
            {
                label: "Cancel",
                onClick: () => { setBanningUser(false) }
            }
        ]

    const prayerCardMenuOptions = () => {
        let menuOptions = [];

        if (isPrayerOfTheWeek) {
            menuOptions.push({ label: 'Edit post', value: 'edit' });
        }

        if (!isPrayerOfTheWeek && isSuperAdmin) {
            menuOptions.push({ label: 'Ban user', value: 'ban' });
        }

        menuOptions.push({ label: 'Delete post', value: 'remove' });

        return menuOptions;
    }

    const prayerCardMenu = (e, optionValue, label, optionIndex) => {
        let value = optionValue ? optionValue.toLowerCase() : '';
        if (value === 'edit') {
            onEdit({ ...data, postId: prayer.postId });
        } else if (value === 'ban') {
            setBanningUser(true);
        } else if (value === 'remove') {
            setShowDeletePostModal((prayer && prayer !== null) ? true : false);
        }
    };

    return (
        <>
            <div className={memberId === prayer.postedUserId
                ? 'prayer-card prayer-card-author'
                : 'prayer-card'} >
                <div className="prayer-card-header d-flex">
                    {/* {isPrayerOfTheWeek &&
                        <div className="prayer-card-header__post-date">
                            <Badge show={true} text="Chaplain" size="medium" />
                            <Typography type="meta-02" color="$color-secondary-a2" tag="div">posted</Typography>
                            <Icon color="$color-secondary-a2" name="dot" size="small" />
                        </div>
                    } */}
                    <Typography type="meta-02" color="$color-secondary-a2">{timeCreated}</Typography>
                    {(prayer.createdAt.toString() !== prayer.editedAt.toString() || (prayer.metadata && prayer.metadata.edited)) &&
                        <div className="prayer-card-header__post-date">
                            <Icon color="$color-secondary-a2" name="dot" size="small" />
                            <Typography type="meta-02" color="$color-secondary-a2">Edited</Typography>
                        </div>
                    }
                    <div className="d-flex ml-auto">
                        {typeof data.topics === 'object' && data.topics.join(' ').length > 0 && (
                            <div className="prayer-topics">{typeof data.topics === 'object' ? data.topics.join(' ') : data.topics || ''}</div>
                        )}
                        {showDeletePostModal &&
                            <Modal
                                modalHeader={null/*bugfix: 178658 modalHeader()*/}
                                isOpen={showDeletePostModal}
                                modalBody={modalBody()}
                                modalFooterButtons={modalFooter}
                            />
                        }
                        {banningUser &&
                            <Modal
                                isOpen={banningUser}
                                modalBody={banningUserModalBody()}
                                modalFooterButtons={banningUserModalFooter}
                            />
                        }
                        <div className="prayer-options">
                            <DropDownButtonMenu
                                buttonAs={LinkText}
                                buttonProps={{
                                    icon: "ellipsis",
                                    as: "button",
                                    type: "button"
                                }}
                                onSelect={prayerCardMenu}
                                options={prayerCardMenuOptions()}
                            />
                        </div>
                    </div>
                </div>

                <div className="prayer-card-body">
                    {isPrayerOfTheWeek ?
                        <div className="weekly-update-header">
                            <Typography type="heading-02" bold color="$color-primary-a3" tag="div" textAlign="center">Weekly Update from your Chaplains</Typography>
                            <Typography type="body-02" color="$color-secondary-a2" tag="div">
                                {typeof data.text === 'object' ? data.text.join(' ') : data.text || (typeof data === 'string' ? data : '')}
                            </Typography>
                        </div> :
                        <>
                            <div className="prayer-card-title">{typeof data.title === 'object' ? data.title.join(' ') : data.title || ''}</div>
                            <div className="prayer-card-text">{typeof data.text === 'object' ? data.text.join(' ') : data.text || (typeof data === 'string' ? data : '')}</div>
                        </>
                    }
                </div>
                <div className="prayer-card-footer d-flex justify-content-between">
                    {/* Reactions */}
                    <div className="d-flex prayer-card-reactions"
                        onClick={() => handlePrayerReaction(prayer.postId)}
                    >
                        <div className={prayer.myReactions.includes('love') ? 'svg-reaction-red-heart' : 'svg-reaction-white-heart'} />
                        <div className="reactions-count">{prayer.reactionsCount}</div>
                    </div>

                    {/* Updates (comments) counts */}
                    <div>
                        {!isPrayerOfTheWeek && prayer.commentsCount > 0 && (
                            <div className="prayer-updates" onClick={showHideComments}>
                                {prayer.commentsCount < prayerCommentsMaxLimit ? prayer.commentsCount : prayerCommentsMaxLimit}
                                {` Update${prayer.commentsCount === 1 ? ' ' : 's '}`}
                                <span className={showComments ? 'icon-dd-up' : 'icon-dd'} />
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Prayer Comment cards */}
            {!isPrayerOfTheWeek && prayer.commentsCount > 0 &&
                <Collapse isOpen={showComments}>
                    <div className="prayer-comments-container">
                        {allComments && allComments.map(
                            commentId => <CommentCard key={commentId} memberId={memberId} commentId={commentId} postId={prayer.postId} onEdit={onEdit} onActionComplete={onCommentActionComplete} />
                        )}
                    </div>
                </Collapse>
            }

            {/* Comment form */}
            {!isPrayerOfTheWeek && ((memberId === prayer.postedUserId || userRole === 'moderator')) &&
                <CommentForm memberId={memberId} prayer={prayer} onActionComplete={onCommentActionComplete} />
            }

            {isPrayerOfTheWeek &&
                <Divider orientation="horizontal" mTop="large" mBottom="large" mLeft="none" mRight="none" />
            }
        </>
    );
}

const mapStateToProps = state => {
    return {
        userRole: state.prayerFeature.userRole,
        prayerCommentsMaxLimit: state.session.serverData.prayerCommentsMaxLimit,
        screenBreakPoint: state.common.screenBreakPoint
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAllPrayers: callback => dispatch({ type: types.GET_ALL_PRAYERS, callback }),
        getMyPrayers: (memberId, callback) => dispatch({ type: types.GET_MY_PRAYERS, memberId, callback }),
        deletePrayer: (prayer, reasonForDelete, callback) => {
            dispatch({ type: types.DELETE_PRAYER, prayer, reasonForDelete, callback });
        },
        notifyDeletedPrayer: (prayer, reasonForDelete) => dispatch({ type: types.NOTIFY_DELETED_PRAYER, prayer, reasonForDelete }),
        banUser: (userId, callback) => dispatch({ type: types.BAN_USER, userId, callback }),
        addPrayerReaction: (postId, callback) => {
            dispatch({ type: types.ADD_PRAYER_REACTION, postId, callback })
        },
        removePrayerReaction: (postId, callback) => {
            dispatch({ type: types.REMOVE_PRAYER_REACTION, postId, callback })
        },
        getComments: (postId, callback) => dispatch({ type: types.GET_COMMENTS, postId, callback })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrayerCard);